/* eslint-disable no-unused-vars */
// @flow
import React, { useState } from 'react';

import { ReactComponent as Cross } from '../../assets/icons/input-cross.svg';

import FreeModal from 'components/FreeModal/FreeModal';
import styles from './styles.module.scss';

// eslint-disable-next-line flowtype/no-types-missing-file-annotation
type Props = {
  value: string,
  placeholder: string,
  onChange: (value: string) => void,
  onBlur: (value: any) => void,
  isFreeUser?: boolean,
  disabled?: boolean,
  withSearchButton?: boolean,
  onSearchClick?: () => void,
  onClear?: () => void,
};

const Input = ({
  value,
  placeholder,
  onChange,
  onBlur,
  isFreeUser,
  disabled,
  withSearchButton = false,
  onSearchClick,
  onClear,
}: Props) => {
  const [isFreeModalVisible, setFreeModalVisible] = useState(false);
  const handleDrop = () => {
    if (withSearchButton) {
      onClear();
      return onChange('');
    }
    return onChange('');
  };

  return (
    <div className={styles.inputContainer}>
      <FreeModal visible={isFreeModalVisible} forControl />
      <div className={styles.inputWrapper}>
        <input
          onMouseOver={() => (isFreeUser ? setFreeModalVisible(true) : null)}
          onFocus={() => (isFreeUser ? setFreeModalVisible(true) : null)}
          onMouseOut={() => (isFreeUser ? setFreeModalVisible(false) : null)}
          onBlur={() => (isFreeUser ? setFreeModalVisible(false) : null)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && withSearchButton) {
              onSearchClick();
            }
          }}
          className={styles.input}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          disabled={isFreeUser || disabled}
        />
        {
          withSearchButton && (
            <button
              type="button"
              className={styles.searchButton}
              onClick={onSearchClick}
            >
              search
            </button>
          )
        }
        {
        !isFreeUser && (
          <button
            type="button"
            onClick={() => handleDrop()}
            className={styles.button}
            disabled={isFreeUser || disabled}
          >
            <Cross className={styles.cross} />
          </button>
        )
      }
      </div>
    </div>
  );
};
export default Input;
